<script setup lang="ts">
import type { NuxtError } from '#app';
import type { PropType } from '#imports';
import { DefaultButton } from 'r3ui-lib';

const { t } = useI18n();

const props = defineProps({
  error: {
    type: Object as PropType<NuxtError>,
    required: true,
  },
});
const { error } = props;

const goHome = async () => await clearError({ redirect: '/' });
</script>

<template>
  <div class="error__wrapper">
    <h1>{{ error.statusCode }} {{ t('pages.error_404') }}</h1>
    <div v-if="error.statusCode == 404" class="error__message">
      {{ t('pages.page_not_found') }}
      <DefaultButton :label="t('pages.go_home')" @submit="goHome" />
    </div>
    <div v-else class="error__message">{{ error.statusMessage }}</div>
  </div>
</template>

<style scoped lang="scss">
.error__message {
  color: var(--color-dark-gray);
  text-align: center;
  font-size: 20px;
  font-weight: 400;
  line-height: 26px;
  margin-bottom: 40px;
}

.error__wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
  min-height: 80vh;
}
</style>
